module.exports = __webpack_public_path__ + "img/temp_instagram6.6f22dff8.jpg";